<template>
    <div class="main">
        <div class="loginTop">
            <img class="topLogo" src="/static/images/utils/logo1.png" />
            <div class="ltSysName">{{ sysName }}</div>
        </div>
        <div class="loginForm">
            <div class="ltTabBar">
                <div :class="'ltTabItem '+(loginType==n.value?'ltTabSel':'')" v-for="(n,i) in loginTypeOptions" :key="i" @click="toggleTab(n.value)">{{ n.label }}</div>
            </div>
            <el-form ref="form" :model="loginForm" label-width="0px">
                <el-form-item>
                    <el-input v-if="loginType==21" class="logInt" v-model="loginForm.userAccount" :placeholder="userAccount" size="big" type="text"></el-input>
                    <el-input v-if="loginType==31" class="logInt" v-model="loginForm.phone" placeholder="手机号" size="big" type="text"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input class="logInt" v-model="loginForm.password" :placeholder="$t('login.password')" size="big" type="password" show-password></el-input>
                </el-form-item>
                <el-form-item v-if="loginType==21">
                    <el-radio-group v-model="stageType">
                        <el-radio v-for="(n,i) in stageOptions" :label="n.value" :key="i">{{ n.label }}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div v-if="loginType==31" class="txtBtnRow">
                <div class="txtBtnItem">
                    <el-button type="text" @click="toReg">用户注册</el-button>
                </div>
                <div class="txtBtnItem" style="text-align: right;">
                    <el-button type="text" @click="toResetPwd">重置密码</el-button>
                </div>
            </div>

            <el-button @click="login" type="primary" class="loginBtn">{{$t('login.btn')}}</el-button>
        </div>

        <bot-nav></bot-nav>

        <el-dialog :title="centerDialogTit" :custom-class="dialogClass" :width="centerDialogWidth" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true"
            :visible.sync="centerDialogVisible" :fullscreen="centerDialogFs" v-if="centerDialogVisible" append-to-body>
            <component :is="centerComp.con" :key="centerComp.ts" :param="centerComp.param" @closeCallback="centerDialogVisible=false" @confirmCallback="centerConfirmCallback"></component>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "login",
    data() {
        return {
            sysName: config.sysName,
            loginForm: {
                userAccount: '',
                phone: '',
                password: '',
            },
            userAccount: '身份证号',
            loginType: 21,
            loginTypeOptions: [
                {
                    label: '测评用户',
                    value: 21
                },
                {
                    label: '家长/老师',
                    value: 31
                },
            ],
            param: {},

            stageType: 1,
            stageOptions: [
                {
                    label: '中小学',
                    value: 1
                },
                // {
                //     label: '大学',
                //     value: 2
                // },
            ],

            centerDialogTit: '',
            centerDialogWidth: '660px',
            dialogClass: '',
            centerDialogFs: false,
            centerDialogVisible: false,
            centerComp: {},
        };
    },
    methods: {
        toggleTab(lt) {
            this.loginType = lt;
        },
        login: function () {
            let _this = this;
            if (this.loginType == 21) {
                this.req('/common/asmt_login', this.loginForm, function (data) {
                    if (data.success) {
                        _this.initAsmtData(data.obj);
                        sessionStorage.setItem("stageType", _this.stageType);

                        if (_this.param.callback) {
                            _this.toCallback();
                        } else {
                            if (_this.stageType == 1) {
                                _this.$router.push("/asmt/index");
                            } else if (_this.stageType == 2) {
                                _this.$router.push("/cust/index");
                            }
                        }
                    } else {
                        _this.$message.error(data.message);
                    }
                })
            } else if (this.loginType == 31) {
                this.req('/common/cust_login', this.loginForm, function (data) {
                    if (data.success) {
                        _this.initCustData(data.obj);

                        if (_this.param.callback) {
                            _this.toCallback();
                        } else {
                            _this.$router.push("/cust/index");
                        }
                    } else {
                        _this.$message.error(data.message);
                    }
                })
            }
        },
        initAsmtData: function (data) {
            sessionStorage.setItem("uid", data.id);
            sessionStorage.setItem("showName", data.realName);
            sessionStorage.setItem("head", data.head ? data.head : '');
            sessionStorage.setItem("type", data.type);
        },
        initCustData: function (data) {
            sessionStorage.setItem("uid", data.id);
            sessionStorage.setItem("showName", data.nickName);
            sessionStorage.setItem("head", data.head ? data.head : '');
            sessionStorage.setItem("phone", data.phone);
            sessionStorage.setItem("type", data.type);
            sessionStorage.setItem("bizCount", data.bizCount);
        },
        toCallback: function () {
            this.$router.push(this.param.callback);
        },
        ckNewVersion: function () {
            this.req('/common/qry_web_version', {}, function (data) {
                if (data.success) {
                    let newVersion = data.obj.split(',')[2];
                    let locVersion = localStorage.getItem('qn2Version');
                    localStorage.setItem('qn2Version', newVersion);

                    if (locVersion && newVersion != locVersion) {
                        window.location.reload(true);
                    }
                }
            }, 'get')
        },
        toReg: function () {
            this.centerComp = {
                con: () => import('@/components/cust/reg/reg.vue'),
                ts: new Date().getTime(),
                param: {},
            };
            this.centerDialogTit = '注册';
            this.centerDialogWidth = this.lib.popWidth(660, 0.9);
            this.dialogClass = '';
            this.centerDialogVisible = true;
        },
        toResetPwd: function () {
            this.centerComp = {
                con: () => import('@/components/cust/reg/reset_pwd.vue'),
                ts: new Date().getTime(),
                param: {},
            };
            this.centerDialogTit = '重置密码';
            this.centerDialogWidth = this.lib.popWidth(660, 0.9);
            this.dialogClass = '';
            this.centerDialogVisible = true;
        },
        centerConfirmCallback: function (param) {
            if (param && param.code) {
                if (param.code == 'cust_ok') {
                    // this.centerDialogVisible = false;
                }
            }
        },
    },
    mounted: function () {
        this.$nextTick(function () {
            console.log("mounted login -- >");
            let _this = this;
            let type = this.$route.query.type;
            if (type) {
                this.loginType = parseInt(type);
            }
            if (this.$route.query.param) {
                this.param = JSON.parse(this.$route.query.param);
            }
            // this.ckNewVersion();
        });
    }
};
</script>

<style scoped>
.main {
    height: 100vh;
    background-image: url("/static/images/pic/bg1.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow-y: auto;
}
.loginForm {
    width: 100%;
    padding: 40px 50px 30px;
    background-color: #fff;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    margin: 40px auto 0px;
    box-sizing: border-box;
    max-width: 550px;
    min-width: 360px;
    position: relative;
}

.ltTabBar {
    width: 100%;
    height: 40px;
    position: absolute;
    z-index: 1;
    left: 0px;
    top: -39px;
    display: flex;
}
.ltTabItem {
    flex: 1;
    text-align: center;
    line-height: 45px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: #eef5fc;
    overflow: hidden;
    font-size: 14px;
    font-weight: bold;
    color: #666;
    cursor: pointer;
}
.ltTabSel {
    background-color: #fff;
    color: #077cf5;
}

.loginBtn {
    width: 100%;
    box-sizing: border-box;
    border-radius: 20px;
    margin: 15px 0 0;
}
.logInt /deep/ .el-input__inner {
    border-color: #077cf5;
}
.loginTop {
    height: calc(50vh - 200px);
    min-height: 200px;
    padding-top: calc(25vh - 160px);
    box-sizing: border-box;
}
.topLogo {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto;
}
.ltSysName {
    text-align: center;
    font-size: 28px;
    margin-top: 20px;
}
@media (max-width: 480px) {
    .ltSysName {
        font-size: 20px;
    }
}

.txtBtnRow {
    display: flex;
}
.txtBtnItem {
    flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue